import React, { Fragment, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Link } from "react-router-dom";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";

//ikonice

library.add(fas);

const NavItem = ({ item, onClick, openMenu, handleToggleMenu }) => {
  const [openMenus, setOpenMenus] = useState({});
  const { t } = useTranslation();

  const [showMenu, setShowMenu] = useState("");

  const location = window.location;

  const isMenuOpen = (menuKey) => openMenu === menuKey;

  const toggleMenuFunction = (page) => {
    handleToggleMenu(page);
    if (page === "dashboard") {
      onClick();
    }
  };

  const toggleMenuFunction2 = (page) => {
    handleToggleMenu(page);
    onClick();
  };

  const toggleMenu = (menuKey) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuKey]: !prevState[menuKey],
    }));
  };

  const menuItemMain = (item) => {
    return (
      <Fragment>
        <FontAwesomeIcon icon={item.icon} className="icon-left-menu" />
        <span>{t("menu." + item.name + "")}</span>
        {item.items?.length > 0 &&
          (isMenuOpen(item.path) ? (
            <KeyboardArrowDownIcon className="icon-meun-down" />
          ) : (
            <KeyboardArrowRightIcon className="icon-meun-up" />
          ))}
      </Fragment>
    );
  };

  const sortedItems = item.items
    ? [...item.items].sort((a, b) => a.position - b.position)
    : [];

  return (
    <li
      className="nav-item nav-item-main"
      onClick={() => toggleMenuFunction(item.path)}
    >
      {item.items?.length > 0 ? (
        <div
          className={`${
            location.pathname.includes("/" + item.path)
              ? "active-menu-item"
              : ""
          } nav-link menu-link nav-link-main`}
        >
          {location.pathname.includes("/" + item.path) && (
            <Fragment>
              <span class="shape1"></span>
              <span class="shape2"></span>
            </Fragment>
          )}
          {menuItemMain(item)}
        </div>
      ) : (
        <Link
          to={`/${item.path}`}
          className={`${
            location.pathname.includes("/" + item.path)
              ? "active-menu-item"
              : ""
          } nav-link menu-link nav-link-main`}
        >
          {location.pathname.includes("/" + item.path) && (
            <Fragment>
              <span class="shape1"></span>
              <span class="shape2"></span>
            </Fragment>
          )}
          {menuItemMain(item)}
        </Link>
      )}
      {item.items?.length > 0 && (
        <div
          className={`menu-dropdown collapse ${
            isMenuOpen(item.path) ? "show" : ""
          }`}
          id="sidebarDashboards"
        >
          <ul className="nav nav-sm flex-column nav-item-submenu">
            <li className="nav-item">
              {sortedItems?.map((item2, key2) => (
                <Link
                  onClick={() => toggleMenuFunction2(item.path)}
                  to={`/${item2.path}`}
                  className={`${
                    location.pathname == "/" + item2.path
                      ? "active-submenu-item"
                      : ""
                  } nav-link`}
                  data-key="t-analytics"
                  key={key2}
                >
                  {t("menu." + item2.name + "")}
                </Link>
              ))}
            </li>
          </ul>
        </div>
      )}
    </li>
  );
};

export default NavItem;
